import styled from 'styled-components';

import { colors } from '../../Pages/Sindico/colors';

export const StyledFolder = styled.div`
  padding: 16px 25px 16px 25px;

  width: 100%;
  max-width: calc((100% / 4) - 16px);
  height: 56px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  gap: 16px;
  border: none;
  background-color: transparent;
  border: 1px solid ${colors.gray[200]};
  border-radius: 8px;
  transition: 0.3s;

  cursor: pointer;

  .folder-name {
    font-size: 16px;
    word-break: break-word;
    color: ${colors.gray[700]};
    font-weight: 500;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &.list {
    height: 80px;
    border: none;
    border-bottom: 1px solid ${colors.gray[300]};
    max-width: 100%;
    gap: 44px;

    .folder-name {
      font-weight: normal;
    }

    box-sizing: border-box;
  }

  &:hover {
    background-color: ${colors.gray[100]};
  }

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;
